// --------------------------------------------------------------
// Created On: 2025-09-30
// Author: Zachary Thomas
//
// Last Modified: 2025-09-30
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import {
  MIN_PASSWORD_LENGTH,
  MAX_PASSWORD_LENGTH,
  VALID_PASSWORD_NUMBER_REGULAR_EXPRESSION,
  VALID_PASSWORD_LOWERCASE_REGULAR_EXPRESSION,
  VALID_PASSWORD_UPPERCASE_REGULAR_EXPRESSION,
  VALID_PASSWORD_SPECIAL_REGULAR_EXPRESSION,
} from "src/constants/miscellaneous";

// Make sure that a password that is submitted meets all the specified requirements.
// Takes a function to pass error messages to and a returns a boolean that is true if the password is valid.
export default function passwordIsValid(
  newPassword: string,
  newConfirmationPassword: string,
  setErrorMessage: (errorMessage: string) => void
): boolean | string {
  if (newPassword.length < MIN_PASSWORD_LENGTH || newPassword.length > MAX_PASSWORD_LENGTH) {
    setErrorMessage(
      `Your new password must be between ${MIN_PASSWORD_LENGTH} and ${MAX_PASSWORD_LENGTH} characters long.`
    );
    return false;
  } else if (!VALID_PASSWORD_NUMBER_REGULAR_EXPRESSION.test(newPassword)) {
    setErrorMessage("Your new password must include at least one number.");
    return false;
  } else if (!VALID_PASSWORD_LOWERCASE_REGULAR_EXPRESSION.test(newPassword)) {
    setErrorMessage("Your new password must include at least one lower case letter.");
    return false;
  } else if (!VALID_PASSWORD_UPPERCASE_REGULAR_EXPRESSION.test(newPassword)) {
    setErrorMessage("Your new password must include at least one upper case letter.");
    return false;
  } else if (!VALID_PASSWORD_SPECIAL_REGULAR_EXPRESSION.test(newPassword)) {
    setErrorMessage("Your new password must include at least one special character.");
    return false;
  } else if (newPassword !== newConfirmationPassword) {
    setErrorMessage("Your new password does not match the confirmation password.");
    return false;
  } else {
    return true;
  }
}
